import React, { createContext } from "react"
import type { MarketingAutomaticoModel } from "../models/marketingAutomaticoModel"
import { MarketingAutomaticoInicial } from "../models/marketingAutomaticoModel"
import type { MarketingAutomaticoAction } from "./marketingAutomaticoActions"

interface MarketingAutomaticoContextValue {
    dados: MarketingAutomaticoModel
    dispatch: React.Dispatch<MarketingAutomaticoAction>
    erroCarregamento: string | null
    recarregar: () => void
}

export const MarketingAutomaticoContext = createContext<MarketingAutomaticoContextValue>({
    dados: MarketingAutomaticoInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    recarregar: () => undefined,
})
